import * as React from "react";
import { AlertColor, Box, Stack } from "@mui/material";
import CclDrawer from "../../../../components/common/cclDrawer/cclDrawer";
import CclDrawerActionBar from "../../../../components/common/cclDrawer/cclDrawerActionBar";
import CclButton from "../../../../components/common/cclButtons/cclButton";
import CclInfoTable from "../../../../components/common/cclInfoTable/cclInfoTable";
import { CclInfoTblInventoryTemplate } from "./cclInfoTbiInventoryTemplate";
import { useGetSessionsInventoryQuery } from "../../../../services/cclTokenedAssessmentApi";
import ComponentLoader from "../../../../components/common/componentLoader";

interface InventoryDrawerProps {
    open: boolean;
    esKey: number;
    onClose: () => void;
    showSnackbar: (message: string, severity: AlertColor) => void;
}

const InventoryDrawer: React.FC<InventoryDrawerProps> = (props) => {
    const {
        data: inventoryData,
        isFetching,
        isError,
    } = useGetSessionsInventoryQuery(props.esKey!, { refetchOnMountOrArgChange: true });

    return (
        <CclDrawer title={"Inventory"} open={props.open} onClose={props.onClose} width="standard">
            <Box sx={{ overflow: "hidden", height: 1 }}>
                <Stack spacing={2} sx={{ overflow: "hidden" }}>
                    {inventoryData != null && !isFetching && !isError ? (
                        <CclInfoTable template={CclInfoTblInventoryTemplate} data={inventoryData} />
                    ) : (
                        <ComponentLoader msg="" />
                    )}
                </Stack>
                <CclDrawerActionBar>
                    <CclButton
                        sx={{ float: "right", mr: 4 }}
                        mode={"primary"}
                        onClick={props.onClose}
                    >
                        Close
                    </CclButton>
                </CclDrawerActionBar>
            </Box>
        </CclDrawer>
    );
};

export default InventoryDrawer;
